import { useState, useEffect, useRef } from 'react';

const usePersistedState = (projectId, key, defaultValue) => {
  const storageKey = `${projectId}_${key}`;
  const isInitialized = useRef(false);
  
  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    if (isInitialized.current) {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } else {
      isInitialized.current = true;
    }
  }, [state, storageKey]);

  const clearState = () => {
    setState(defaultValue);
    localStorage.removeItem(storageKey);
  };

  return [state, setState, clearState];
};

export default usePersistedState;